import { render, staticRenderFns } from "./mario-colesanti.vue?vue&type=template&id=f5e6729a&scoped=true"
import script from "./mario-colesanti.vue?vue&type=script&lang=js"
export * from "./mario-colesanti.vue?vue&type=script&lang=js"
import style0 from "./mario-colesanti.vue?vue&type=style&index=0&id=f5e6729a&prod&scoped=true&lang=css"
import style1 from "./mario-colesanti.vue?vue&type=style&index=1&id=f5e6729a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e6729a",
  null
  
)

export default component.exports